import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  InputNumber, Checkbox
} from "antd";
import {
  PlusOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const TransactionProjectTypeUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const tabTitles = {
    "Proje": 0,
    "Özel Hareket": 1,
    "Masraf/Maliyet Merkezi": 2,
    "Sorumluluk Merkezi": 3,
    "Bölüm": 5,
    "Departman": 6,
    "Grup Numarası": 7,
    "Referans": 8,
    "Özel Kod": 9,
  };
  const onFinish = (values) => {
    values.projectType = tabTitles[props.formTitle]
    RequestHandler.put(`/TransactionProjectType`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="TransactionProjectTypeUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label={`${props.formTitle} Adı`}
            name="name"
            rules={[
              { required: true, message: `Lütfen ${props.formTitle} adını boş bırakmayın.` },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item
            label={`${props.formTitle} Kodu`}
            name="projectCode"
            rules={[
              {
                required: true,
                message: `Lütfen ${props.formTitle} Kodu alanını boş bırakmayın.`,
              },
            ]}
          >
            {(props.formTitle == "Bölüm" || props.formTitle == "Departman") ? (
              <InputNumber min={0} precision={0} style={{ width: "100%" }} />
            ) : (
              <Input />
            )}
          </Form.Item>

          {
            props.formTitle == "Sorumluluk Merkezi" ?
              <>
                <Form.Item label="Hesap Hareketi İçin Varsayılan" name="isHHDefault" valuePropName="checked">
                  <Checkbox />
                </Form.Item>
                <Form.Item label="Pos Tahsilat İçin Varsayılan" name="isDefault" valuePropName="checked">
                  <Checkbox />
                </Form.Item>
              </> : <></>
          }

          {
            props.formTitle == "Özel Kod" || props.formTitle == "Proje" || props.formTitle == "Masraf/Maliyet Merkezi" ?
              <>
                <Form.Item label="Hesap Hareketi İçin  Varsayılan mı?" name="isHHDefault" valuePropName="checked">
                  <Checkbox />
                </Form.Item>
              </> : <></>
          }

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default TransactionProjectTypeUpdateForm;
